module.exports = __webpack_public_path__ + "img/mysoundfiles.44a86811.png";